import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { StatusChangeType } from '@core/offers-data';
import { OfferStatus } from '@core/offers-types';
import type { OfferSimpleListItem } from '@core/offers-ui';
import { OfferStatusComponent } from '@core/offers-ui';
import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  DropdownWidth,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-statuses-dropdown',
  templateUrl: './statuses-dropdown.component.html',
  styleUrls: ['./statuses-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    OfferStatusComponent,
    OverlayOriginDirective,
    TranslatePipe,
    ButtonDropdownIndicatorDirective,
    ButtonComponent,
  ],
})
export class StatusesDropdownComponent {
  @Input() public offer: OfferSimpleListItem;
  @Input() public state: 'read-only' | 'default' = 'default';
  @Input() public hasPublishActions = false;
  @Input() public isPlain = true;
  public action = output<StatusChangeType>();

  public StatusChangeType: typeof StatusChangeType = StatusChangeType;
  public OfferStatus: typeof OfferStatus = OfferStatus;
  public DropdownWidth = DropdownWidth;

  constructor(private cdRef: ChangeDetectorRef) {}

  public openStatusDropdown(dropdown: ConnectedOverlayDirective): void {
    if (this.state !== 'default') return;
    dropdown.open = !dropdown.open;
    this.cdRef.detectChanges();
  }

  public changeStatus(name: StatusChangeType): void {
    if (this.state !== 'default') return;
    this.action.emit(name);
  }
}
